import { useContext } from 'react';
import { EncountersTrackerContext } from "../contexts/encounter/EncountersTrackerContext";

export function useEncountersTracker() {
    const ctx = useContext(EncountersTrackerContext);
    if (!ctx) {
        throw new Error('No provider found for ');
    }
    
    return ctx;
}